'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonOutline = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _styledSystem = require('styled-system');

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonOutline = exports.ButtonOutline = (0, _components2.default)({
  extend: _Button2.default,
  color: 'blue',
  bg: 'transparent'
}, function (props) {
  return {
    boxShadow: 'inset 0 0 0 2px ' + (0, _styledSystem.themeGet)('colors.' + props.color, props.color)(props)
  };
});

ButtonOutline.displayName = 'ButtonOutline';

exports.default = ButtonOutline;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/ButtonOutline.js
// module id = 3959
// module chunks = 16